import { render, staticRenderFns } from "./resource-form-modal.vue?vue&type=template&id=2f1697c4"
import script from "./resource-form-modal.vue?vue&type=script&lang=js"
export * from "./resource-form-modal.vue?vue&type=script&lang=js"
import style0 from "./resource-form-modal.vue?vue&type=style&index=0&id=2f1697c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports